import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
var propTypes = {
  /**
   * TableHead requires TableHeader components as children.
   */
  children: PropTypes.node.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string
};
var defaultProps = {
  className: undefined
};
var TableTR = /*#__PURE__*/styled.tr.withConfig({
  displayName: "TableTR",
  componentId: "sc-lo6q2y-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));

var TableHead = function TableHead(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/React.createElement("thead", {
    className: className
  }, /*#__PURE__*/React.createElement(TableTR, null, children));
};

TableHead.propTypes = propTypes;
TableHead.defaultProps = defaultProps;
export default TableHead;